let button = document.getElementById('scrollToTopButton');

if(button) {
    button.addEventListener('click', function(){
        window.scrollTo({
            top: 0,
            behavior: 'smooth'  // これによりスクロールがなめらかになります
        });
    });
}